import { render, staticRenderFns } from "./addVehiclePollution.vue?vue&type=template&id=7184b6c2"
import script from "./addVehiclePollution.vue?vue&type=script&lang=js"
export * from "./addVehiclePollution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports